import { useTranslation } from "react-i18next";
import NotificationIcon from "../../../assets/img/notification.svg";
import CloseButton from "../../../components/Common/CloseButton";
import Modal from "../../../components/Common/Modal";
import "./notification.scss";
import NotificationCard from "./NotificationCard";
import NotificationListSkeleton from "./NotificationListSkeleton";

const NotificationModal = ({
  show,
  close,
  isLoading,
  notificationData,
  deleteNotificationOnce,
  handleNotificationClick,
  clearAllNotifications,
  canClearAll = true,
  canDelete = true,
  canMarkRead = true,
}) => {
  const { t } = useTranslation("common");
  const list = Array.isArray(notificationData) ? notificationData : [];
  const showSkeleton = isLoading && list.length === 0;
  const showEmpty = !isLoading && list.length === 0;

  const handleClearAll = () => {
    if (!canClearAll) return;
    if (!isLoading && list.length > 0) {
      clearAllNotifications();
    }
  };

  return (
    <Modal
      show={show}
      close={close}
      justify="right"
      containerClassName="notification-modal"
    >
      <div className="bg-white h-100">
        <div className="modal-header notification-modal-header" style={{ borderRadius: 0 }}>
          <h6 className="modal-type notification-modal-title d-flex align-items-center fs-22 gap-2">
            <img
              src={NotificationIcon}
              className="notification-header-icon"
              alt=""
              loading="lazy"
            />
            {t("notifications.title")}
          </h6>
          <div className="d-flex align-items-center gap-3">
            {canClearAll && list.length > 0 && (
              <button
                type="button"
                className="notification-clear-all-btn"
                onClick={handleClearAll}
                disabled={isLoading}
              >
                {t("notifications.clearAll")}
              </button>
            )}
            <CloseButton onClick={close} theme="dark" />
          </div>
        </div>
        <div
          className="modal-body p-3"
          style={{
            overflow: "auto",
            height: "calc(100% - 80px)",
          }}
        >
          {showSkeleton && <NotificationListSkeleton rows={6} />}

          {!showSkeleton &&
            list.map((noti, index) => (
              <NotificationCard
                key={noti.id}
                notification={noti}
                isFetching={isLoading}
                delete={deleteNotificationOnce}
                canDelete={canDelete}
                canMarkRead={canMarkRead}
                handleNotificationClick={(id, read) =>
                  handleNotificationClick(id, index, read)
                }
              />
            ))}

          {showEmpty && (
            <p className="notification-empty py-4 w-100 text-center">
              {t("notifications.noNotifications")}
            </p>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default NotificationModal;